import ApiClient from "./ApiClient";
import Store from "../../../store";

class Manager {
    constructor() {
        this.$api = new ApiClient();
    }

    setUser(user) {
        Store.dispatch('auth/setUser', user);
    }

    getUser() {
        return Store.state.auth.user;
    }

    async initUser() {
        try {
            let response = await this.$api.getUserInfo();
            let {data: user} = response.data;
            this.setUser(user);
            return user;
        } catch (e) {
            console.log(e);
            throw e;
        }
    }

    flush() {
        this.setUser(null);
    }

    isBCBA() {
        return Store.getters['auth/isBCBA'];
    }

    isCurator() {
        return Store.getters['auth/isCurator'];
    }

    isTherapist() {
        return Store.getters['auth/isTherapist'];
    }

    isClient() {
        return Store.getters['auth/isClient'];
    }

    isMensurationForbidden() {
      return Store.getters['auth/isMensurationForbidden'];
    }
    isSubscriptionExpiredSoon() {
      return Store.getters['auth/isSubscriptionExpiredSoon']
    }
    subscriptionDaysLeft() {
      return Store.getters['auth/subscriptionDaysLeft']
    }
    can(name) {
        name = 'auth/can' + (name.split('_').map(function(word) {
            var f = word.charAt(0).toUpperCase();
            return f + word.substr(1, word.length-1);
        })).join('');

        // todo: maybe need to check, that it is function
        if (Store.getters[name] === undefined) {
            throw new Error(`Getter ${name} is not defined`);
        }
        return Store.getters[name];
    }
}

export default Manager;



// WEBPACK FOOTER //
// ./src/common/auth/rbac/Manager.js